// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".naoLida {\n  font-weight: bold;\n  color: black;\n}", "",{"version":3,"sources":["webpack://src/pages/central/central.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,YAAY;AACd","sourcesContent":[".naoLida {\n  font-weight: bold;\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
